import 'css-chunksrc/client/common/projectsSelection/loader/styles.scss';export default {
  "loader": "_loader_1f8gl_1",
  "item": "_item_1f8gl_5",
  "checkbox": "_checkbox_1f8gl_15",
  "name": "_name_1f8gl_23"
};